<p>mes-fruits works!</p>

<div class="row d-flex justify-content-around align-items-center">

    <div *ngFor="let chaqueFruit of lesFruits" class="maDiv col-3">

        <h2>{{chaqueFruit.nom}}</h2>

        <p>{{chaqueFruit.couleur}}</p>

    </div>


</div>
